import React from 'react';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label, className = '' }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors ${className}`}
  >
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
    {label && <span>{label}</span>}
  </button>
);

export default BackButton;
